import { styled } from "@mui/material/styles"
import { Button } from "@mui/material"

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0.5),
  textTransform: 'none',
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(1.6)
  },
}))
